"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _styles = require("@material-ui/core/styles");
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Menu = _interopRequireDefault(require("../../Menu"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _excluded = ["classes", "dataMetrics", "enableAutoFocus", "children", "isNestedMenu", "className", "disabled", "handleOnKeyDown", "handleMenuClose", "handleMenuOpen", "label", "leftIcon", "parentId", "onClick", "remove", "rightIcon", "selected", "shortCutKey", "subNav", "subNavAnchor", "variant"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ICON_SIZE = 24;
var useStyles = function useStyles(_ref) {
  var disabled = _ref.disabled,
    label = _ref.label,
    remove = _ref.remove,
    rightIcon = _ref.rightIcon,
    selected = _ref.selected,
    variant = _ref.variant;
  var infoText = variant === 'infoText';
  var labelProp = label || variant === 'label';
  return (0, _styles.makeStyles)(function (theme) {
    return {
      leftListItemIcon: {
        marginRight: theme.spacing(1)
      },
      listItemIcon: function listItemIcon() {
        var color = theme.palette.text.secondary;
        if (disabled) {
          color = theme.palette.text.disabled;
        } else if (remove) {
          color = theme.palette.action["delete"];
        }
        return {
          color: color,
          height: ICON_SIZE,
          minWidth: ICON_SIZE,
          width: ICON_SIZE
        };
      },
      rightListItemIcon: {
        padding: 0
      },
      root: function root() {
        var padding = rightIcon ? theme.spacing(0, 1, 0, 2) : theme.spacing(0, 2);
        var commonStyles = {
          '&:focus': {
            background: theme.palette.opacity.black[14]
          },
          '&:hover': {
            background: theme.palette.opacity.black[8]
          },
          alignItems: 'center',
          background: undefined,
          color: theme.palette.text.primary,
          display: 'flex',
          height: 36,
          padding: padding
        };
        if (disabled) {
          return _objectSpread({}, commonStyles, {
            '&:hover': {
              background: 'none'
            },
            cursor: 'default'
          });
        }
        if (selected) {
          return _objectSpread({}, commonStyles, {
            background: theme.palette.opacity.primary[500][14]
          });
        }
        if (infoText) {
          var grayColor = '#F5F5F5';
          return _objectSpread({}, commonStyles, {
            '&:focus': {
              background: grayColor
            },
            '&:hover': {
              background: grayColor
            },
            background: grayColor,
            cursor: 'default',
            height: 'auto',
            minHeight: theme.spacing(3),
            padding: theme.spacing(1, 2),
            whiteSpace: 'normal'
          });
        }
        if (remove) {
          return _objectSpread({}, commonStyles, {
            '&:focus': {
              background: theme.palette.action.deleteBackgroundFocus
            },
            '&:hover': {
              background: theme.palette.action.deleteBackgroundHover
            }
          });
        }
        if (labelProp) {
          return _objectSpread({}, commonStyles, {
            '&:focus': {
              background: theme.palette.common.white
            },
            '&:hover': {
              background: 'none'
            },
            cursor: 'default',
            height: 24
          });
        }
        return commonStyles;
      },
      shortCutKeyText: {
        color: theme.palette.text.secondary,
        margin: '0 0 0 auto',
        padding: theme.spacing(0, 0, 0, 0.5),
        textTransform: 'uppercase'
      },
      textRoot: function textRoot() {
        var color = theme.palette.text.primary;
        if (disabled) {
          color = theme.palette.text.disabled;
        } else if (!selected) {
          if (remove) {
            color = theme.palette.action["delete"];
          } else if (labelProp || infoText) {
            color = theme.palette.text.secondary;
          }
        }
        return {
          color: color,
          fontWeight: selected ? 500 : undefined,
          marginRight: 'auto',
          textTransform: labelProp ? 'capitalize' : undefined
        };
      }
    };
  })();
};
var defaultProps = {
  dataMetrics: {
    root: 'fuse_menu_item'
  }
};
var StyledMenuItem = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var propClasses = props.classes,
    dataMetrics = props.dataMetrics,
    enableAutoFocus = props.enableAutoFocus,
    children = props.children,
    isNestedMenu = props.isNestedMenu,
    className = props.className,
    disabled = props.disabled,
    handleOnKeyDown = props.handleOnKeyDown,
    handleMenuClose = props.handleMenuClose,
    handleMenuOpen = props.handleMenuOpen,
    label = props.label,
    leftIcon = props.leftIcon,
    parentId = props.parentId,
    onClick = props.onClick,
    remove = props.remove,
    rightIcon = props.rightIcon,
    selected = props.selected,
    shortCutKey = props.shortCutKey,
    subNav = props.subNav,
    subNavAnchor = props.subNavAnchor,
    variant = props.variant,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var localClasses = useStyles({
    disabled: disabled,
    label: label,
    remove: remove,
    rightIcon: rightIcon,
    selected: selected,
    variant: variant
  });
  var classes = (0, _lodash.mergeWith)(localClasses, propClasses, function (objValue, srcValue) {
    return "".concat(objValue, " ").concat(srcValue);
  });
  var overlineStyle = label || variant === 'label' || variant === 'infoText';
  var disableOnClick = disabled || label || variant === 'label' || variant === 'infoText';
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({
    classes: {
      root: classes.root
    },
    className: className,
    "data-metrics": dataMetrics.root,
    onClick: disableOnClick ? undefined : onClick,
    onKeyDown: function onKeyDown(event) {
      return handleOnKeyDown(event);
    },
    onMouseEnter: subNav && handleMenuOpen,
    onMouseLeave: subNav && handleMenuClose,
    ref: ref
  }, restProps), leftIcon && /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    className: (0, _classnames["default"])(classes.listItemIcon, classes.leftListItemIcon)
  }, leftIcon), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    classes: {
      root: classes.textRoot
    },
    variant: overlineStyle ? 'overline' : 'body1'
  }, children), shortCutKey && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.shortCutKeyText,
    variant: "body1"
  }, shortCutKey), rightIcon && /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    className: (0, _classnames["default"])(classes.listItemIcon, classes.rightListItemIcon)
  }, rightIcon), subNav && !isNestedMenu && /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    anchorEl: subNavAnchor,
    id: "".concat(parentId, "-subnav"),
    isNestedMenu: true,
    onClose: handleMenuClose,
    onMouseLeave: handleMenuClose,
    open: Boolean(subNavAnchor),
    shouldAutoFocus: enableAutoFocus,
    subnav: true
  }, subNav));
});
StyledMenuItem.defaultProps = defaultProps;
StyledMenuItem.displayName = 'MenuItem';
StyledMenuItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true`, the MenuItem will be styled as a label.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element, _propTypes["default"].string]),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * If `true`, the MenuItem will be styled as disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * @ignore
   * Internal prop used to manually keep track of fucus in the menu for accessibility
   * This allows the autofocus to be removed with a mouse enter
   */
  enableAutoFocus: _propTypes["default"].bool,
  /**
   * Close the menu
   */
  handleMenuClose: _propTypes["default"].func,
  /**
   * Open the Menu
   */
  handleMenuOpen: _propTypes["default"].func,
  /**
   * callback to handle on key down event
   */
  handleOnKeyDown: _propTypes["default"].func,
  /**
   * If `true`, styles and action will be set to handle nest menu
   */
  isNestedMenu: _propTypes["default"].bool,
  /**
   * If `true`, the MenuItem will be styled as a label.
   */
  label: _propTypes["default"].bool,
  /**
   * Icon to be displayed on the left side of the MenuItem's children.
   */
  leftIcon: _propTypes["default"].node,
  /**
   * @ignore
   */
  onClick: _propTypes["default"].func,
  /**
   * @ignore
   * Internal prop used to manually keep track of fucus in the menu for accessibility
   */
  parentId: _propTypes["default"].string,
  /**
   * If `true`, the MenuItem will be styled as a Delete/Remove action.
   */
  remove: _propTypes["default"].bool,
  /**
   * Icon to be displayed on the right side of the MenuItem's children.
   */
  rightIcon: _propTypes["default"].node,
  /**
   * If `true`, the MenuItem will be styled as selected.
   */
  selected: _propTypes["default"].bool,
  /**
   * Text to be displayed on the right side of the MenuItem's children.
   * Could also be used as a hint.
   */
  shortCutKey: _propTypes["default"].string,
  /**
   * Pass in additional MenuItems (wrapped with Fragements or an Array) to make a sub/nested navigation menu.
   * Menu nesting is limited to one level, additional subNav elements will not apply
   */
  subNav: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element]),
  /**
   * Anchor reference for the popper of the sub nav
   */
  subNavAnchor: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })]),
  /**
   * If `infoText`, the MenuItem will be styled as info text.
   * If `label`, the MenuItem will be styled as label.
   * If `standard`, the MenuItem will be styled as standard.
   */
  variant: _propTypes["default"].oneOf(['infoText', 'label', 'standard'])
} : {};
var _default = StyledMenuItem;
exports["default"] = _default;